import axios from "axios";
import moment from "moment";

/**
 * Fetch the single-day funnel for a given site.
 * Returns { date, siteId, counts: { step0, step0_5, step1, step2, step3, completed } }.
 */
export async function fetchFunnelForDay({ date, siteId, token }) {
  const dateStr = moment(date).format("YYYYMMDD").toString();
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/incomplete/funnel`,
    {
      params: { date: dateStr, siteId },
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        siteid: siteId,
        authorization: token,
      },
    }
  );
  return res.data;
}

/**
 * Fetch a 7-day trailing trend ending on `endDate`.
 * Returns { siteId, days: [{ date, step0, step0_5, step1, step2, step3, completed }] }.
 */
export async function fetchFunnelTrend({ endDate, days = 7, siteId, token }) {
  const end = moment(endDate);
  const start = moment(endDate).subtract(days - 1, "days");
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/incomplete/funnel`,
    {
      params: {
        startDate: start.format("YYYYMMDD"),
        endDate: end.format("YYYYMMDD"),
        siteId,
      },
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        siteid: siteId,
        authorization: token,
      },
    }
  );
  return res.data;
}

/**
 * Compute drop-off percentage between two cumulative step counts.
 * Returns null if `from` is 0 (no baseline).
 */
export function computeDropOff(from, to) {
  if (!from) return null;
  return ((from - to) / from) * 100;
}

/**
 * Compute conversion rate (%) — completed over step0.
 */
export function computeConversionRate(counts) {
  if (!counts || !counts.step0) return 0;
  return (counts.completed / counts.step0) * 100;
}
